module.exports = __webpack_public_path__ + "img/khipu.72e898c.svg";